module.exports = __webpack_public_path__ + "img/20200516_095142.9406b4f3.jpg";